import React, { useRef, useEffect } from 'react';

const ParticleBackground: React.FC = () => {
  const canvasRef = useRef<HTMLCanvasElement>(null);
  const particles = useRef<any[]>([]);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext('2d');
    let animationId: number;
    let width = window.innerWidth;
    let height = window.innerHeight;
    canvas.width = width;
    canvas.height = height;

    // Particle setup
    const numParticles = Math.floor((width * height) / 3500);
    particles.current = Array.from({ length: numParticles }, () => ({
      x: Math.random() * width,
      y: Math.random() * height,
      r: 1.2 + Math.random() * 2.5,
      dx: (Math.random() - 0.5) * 0.15,
      dy: (Math.random() - 0.5) * 0.15,
      glow: 0.15 + Math.random() * 0.25,
      color: `rgba(56,189,248,${0.15 + Math.random() * 0.25})`, // cyan glow
    }));

    function draw() {
      ctx!.clearRect(0, 0, width, height);
      for (const p of particles.current) {
        ctx!.beginPath();
        ctx!.arc(p.x, p.y, p.r, 0, 2 * Math.PI);
        ctx!.shadowColor = p.color;
        ctx!.shadowBlur = 18 * p.glow;
        ctx!.fillStyle = p.color;
        ctx!.fill();
        ctx!.closePath();
        // Move
        p.x += p.dx;
        p.y += p.dy;
        // Wrap
        if (p.x < 0) p.x = width;
        if (p.x > width) p.x = 0;
        if (p.y < 0) p.y = height;
        if (p.y > height) p.y = 0;
      }
      animationId = requestAnimationFrame(draw);
    }
    draw();

    // Handle resize
    const handleResize = () => {
      width = window.innerWidth;
      height = window.innerHeight;
      canvas.width = width;
      canvas.height = height;
    };
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
      cancelAnimationFrame(animationId);
    };
  }, []);

  return (
    <canvas
      ref={canvasRef}
      className="fixed inset-0 w-full h-full z-0 pointer-events-none animate-fade-in"
      style={{ position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh', background: 'transparent' }}
    />
  );
};

export default ParticleBackground; 